export default __webpack_public_path__ + "static/media/download.b17190d9.svg";